import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BOARDING_GROUP_PATH } from '../../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../../layout/Content';
import BoardingGroupForm from './BoardingGroupForm';
import { postBoardingGroup } from '../../../../../actions/itinerary/BoardingGroup';

const NewBoardingGroup = ({ breadcrumbs, dispatchPostBoardingGroup }) => {
  const onSubmit = (formValues) => {
    const locationIdList = formValues.locationList.map(
      (location) => location.value,
    );
    const newFormValues = {
      ...formValues,
      routeId: formValues.route.value,
      locationIdList,
    };
    dispatchPostBoardingGroup(newFormValues);
  };

  const content = <BoardingGroupForm onSubmit={onSubmit} />;

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Grupo de Embarque"
      subtitle="Crear nuevo grupo de embarque"
      content={content}
    />
  );
};

NewBoardingGroup.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostBoardingGroup: PropTypes.func.isRequired,
};

const mapStateToProps = ({ ItineraryUnit }) => ({
  breadcrumbs: [
    ...ItineraryUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Grupos de Embarque',
      href: BOARDING_GROUP_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

const mapDispatchToProps = {
  dispatchPostBoardingGroup: postBoardingGroup,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewBoardingGroup);
